import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const CardContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(2),
  height: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}))

export const CardTitle = styled('span')(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.text.secondary,
  letterSpacing: '0.75px'
}))

export const TrendWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color'
})<{ color: string }>(({ theme, color }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '0.75rem',
  fontWeight: theme.typography.fontWeightMedium,
  color
}))

export const ValueWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontSize: '1.75rem',
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.2,
  margin: `${theme.spacing(0.5)} 0`,
}))

export const StickyBottomWrapper = styled(Box)(() => ({
 display: 'flex',
 flexDirection: 'column',
 flex: 1,
 justifyContent: 'flex-end',
 marginTop: 'auto'
}))
